import { STORES_API } from 'modules/stores/api/stores-api'
import { StoreListApiInterface } from 'modules/stores/types/stores-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export const useStoreWithOptinItemsList = (shouldFetch?: boolean) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, StoreListApiInterface['items']>({
    method: RequestMethodsEnum.get,
  })

  return useControlledSwr(
    () => `${STORES_API}/choice-list-tmp?items.type=optin`,
    fetcher,
    {},
    Boolean(user && shouldFetch),
  )
}
